__turbopack_context__.v({
  "social_nav": "styles-module-scss-module__a2tRNq__social_nav",
});
